import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import LoginSignupV2 from "../login-signup-v2";
import ErrorHandler from "../../shared/with-error-handler";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";
import PageLoader from "../../shared/page-loader";
import { appUrl } from "../../../constants/url-constants";
import styles from "./styles.css";

const AccountLogin = ({
    history,
    isLoggedIn
}) => {

    const [isLoading, setIsLoading] = useState(true);

    const queryParams = parseLocationSearchParams(history.location.search);
    const { redirectTo } = queryParams || {};

    useEffect(() => {
        if (isLoggedIn) {
            window.location.href = `${appUrl()}`;
        } else {
            setIsLoading(false);
        }
    /* eslint-disable react-hooks/exhaustive-deps */
    }, [isLoggedIn]);

    const onClose = () => {
        history.replace("/");
    };

    const successCallback = () => {
        if (redirectTo && redirectTo.startsWith("/")) {
            window.location.href = `${appUrl()}${redirectTo}`;
        } else {
            window.location.href = `${appUrl()}`;
        }
    };

    if (isLoading) return <PageLoader />;

    return (
        <React.Fragment>
            <Helmet>
                <title>Cars24 Login</title>
                <meta
                    name="description"
                    content="Login to Cars24 for a seamless buying or selling of a car.
                    Log in to check the status of your transaction with ease.
                    Simplify the car trading process with Cars24 today!"
                />
                <link href={`${appUrl()}/account/login/`} rel="canonical" />
            </Helmet>
            <ErrorHandler>
                <React.Fragment>
                    <div styleName="styles.container" />
                    <LoginSignupV2
                        onClose={onClose}
                        onLoginSuccessCallback={successCallback}
                        isVisible={true}
                        overlayClass={"removeOverlay"}
                    />
                </React.Fragment>
            </ErrorHandler>

        </React.Fragment>
    );
};

AccountLogin.propTypes = {
    history: PropTypes.object,
    isLoggedIn: PropTypes.bool
};

export default AccountLogin;
